export const APP_NAME = 'Luxe Rides';
export const APP_DESCRIPTION = 'Închirieri Auto de Lux';
